// Define the Splide configuration object
const splideConfigRelated = {
  perPage: 4,
  focus: 0,
  omitEnd: true,
  perMove: 1,
  gap: '32px',
  // Enable these controls by default
  pagination: true,
  arrows: true,
  drag: true,
  breakpoints: {
    1120: {
      perPage: 2,
      perMove: 1,
      gap: '32px',
      padding: { right: '12.4rem' },
    },
    767: {
      perPage: 1,
      perMove: 1,
      gap: '20px',
      padding: { right: '20%' },
    },
    430: {
      perPage: 1,
      perMove: 1,
      gap: '20px',
      padding: { right: '30%' },
    },
  },
};

// Function to initialize Splide (now much simpler)
function initSplideRelated() {
  // Select all sliders with this ID to avoid re-initialization errors
  document.querySelectorAll('#related-products:not(.is-initialized)').forEach(slider => {
    new Splide(slider, splideConfigRelated).mount();
  });
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initSplideRelated);
document.addEventListener('shopify:section:load', initSplideRelated);